import { deleteLead } from "api/Leads";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

export const useDeleteLeads = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteLead, {
    onSuccess: () => {
      queryClient.invalidateQueries('leads');
      toast.success("Deleted Successfully");
    },
    onError: () => {
      toast.error(`Something went wrong`);
    },
  });
};
